import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { IdentityServiceImpl } from './identity.service';
import { RouteService } from '@helpers/routing/router.service';

/**
 * Guard para autorizar acceso a las rutas de la aplicación
 * @returns true si el usuario está autorizado, false en caso contrario
 */
export const AuthorizationGuard = async (): Promise<boolean> => {
  const identityService = inject(IdentityServiceImpl);
  const routeService = inject(RouteService);

  if (!identityService.isLoggedIn()) {
    try {
      const sessionValid = await firstValueFrom(identityService.checkSession());
      if (!sessionValid) {
        routeService.navigateTo('/access-denied');
        return false;
      }
      return true;
    } catch {
      // redireccion manejada por el interceptor
      return false;
    }
  }

  return true;
};
